import { Navigate, useParams } from 'react-router-dom'

/** Legacy `/rewards/view/:transactionId` links open the claimed-tab modal in-app. */
export function RewardViewRedirectPage() {
  const { transactionId } = useParams<{ transactionId: string }>()

  if (!transactionId) {
    return <Navigate to="/rewards?tab=claimed" replace />
  }

  return <Navigate to={`/rewards/claimed/${transactionId}?tab=claimed`} replace />
}
